import { App } from '../../App';
import { BasicFrame } from 'components/organisms';
import { Button, Card, Spacer, Text, Title } from 'components';
import { CheckmarkIcon } from 'components/icons';
import { frameConfigBasic } from '../../AppConfig';
import { getFetchHeaders } from '../../utils/fetchHeaders';
import { getScreenTranslation } from '../../utils/translations';
import { PAYLAND_SEARCHPARAM_CONTINUE } from '../../hooks/usePayment';
import { routes } from '../../routes';
import { useErrorManager } from 'InternalLibrary';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axiosInstance from '../../utils/axiosInstance';
import classes from 'classnames';
import layout from 'scss/layout.module.scss';
import React, { useEffect } from 'react';
import styles from './PaylandSuccess.module.scss';

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const { setError } = useErrorManager();
  const i18Next = useTranslation();
  const searchParams = new URLSearchParams(window.location.search);

  const content = getScreenTranslation('paymentSuccess', i18Next);

  const apiAutoRepay = App.useApi(
    'client/payment-preferences/auto-repay',
    'PUT',
  );

  useEffect(() => {
    try {
      // user preferences
      apiAutoRepay.fetch({
        headers: getFetchHeaders(),
        body: {
          autoRepay: true,
        },
      });

      // If the user has a loan, the autorepayment will be activated
      axiosInstance.post('/client/loans/latest/auto-repay', {
        autoRepay: true,
      });
    } catch (e) {
      setError(e);
    }
  }, []);

  return (
    <BasicFrame
      {...frameConfigBasic}
      headerLayout="centered"
      contentWrapperClassName={classes(
        styles['body-wrapper'],
        layout['width-md'],
      )}
    >
      <Card
        className={classes(styles.container, layout['full-width-border-box'])}
      >
        <Title
          className={classes([styles.title])}
          dataTest="continue-btn-title"
          icon={<CheckmarkIcon />}
          text={content.title}
        />
        <Spacer marginTop={{ default: '40px', xs: '25px' }}>
          <Text
            className={styles['helper-text']}
            dataTest="continue-btn-helper-text"
            text={content.bodyTitle}
            weight="medium"
          />
        </Spacer>
        <Spacer
          marginTop="20px"
          marginBottom={{ default: '55px', s: '40px' }}
          className={styles['text-list']}
        >
          <Text
            className={styles['helper-text']}
            text={content.bodyOption1}
            dataTest="continue-btn-option1"
          />
          <Text
            className={styles['helper-text']}
            text={content.bodyOption2}
            dataTest="continue-btn-option2"
          />
          <Text
            className={styles['helper-text']}
            text={content.bodyOption3}
            dataTest="continue-btn-option3"
          />
        </Spacer>
        <Button
          className={classes(
            layout['width-sm'],
            layout['full-width-border-box'],
          )}
          onClick={() =>
            navigate(
              searchParams.get(PAYLAND_SEARCHPARAM_CONTINUE) ||
                routes.FirstLoan_Welcome,
            )
          }
          dataTest="continue-btn-btn"
        >
          {content.primaryBtn}
        </Button>
      </Card>
    </BasicFrame>
  );
}
